import React from "react";
import {
  FaGithub,
  FaCamera,
  FaCircleNotch,
  FaApple,
  FaSearch,
  FaPlusSquare,
  FaBiohazard
} from "react-icons/fa";
const Services = () => {
  const [header] = React.useState({
    mainHeader: "SERVICES",
    subHeading: "My Services",
    text: "As a microbiologist and web developer, I offer a unique combination of skills and expertise, including expertise in microorganisms, data analysis, and web development. I can help you with research, consulting, data analysis, and web development projects to achieve your goals.",
  });
  const [state] = React.useState([
    {
      id: 1,
      icon: <FaGithub className="commonIcons" />,
      heading: "Web Development",
      text: "I offer web development services including custom development, design, and maintenance. I have expertise in JavaScript, HTML, CSS, and the MERN stack. I can help you build and maintain a responsive website or application.",
    },
    {
      id: 2,
      icon: <FaApple className="commonIcons" />,
      heading: "App Development",
      text: "I offer app development services using React Native, a framework for building cross-platform apps. My services include design, building, testing, and maintenance. I can help you create a custom app for iOS and Android devices.",
    },
    {
      id: 3,
      icon: <FaCircleNotch className="commonIcons" />,
      heading: "Web Design",
      text: "I offer professional web design services including layout design, graphic design, and usability testing. I have expertise in HTML, CSS, and responsive design principles. I can help you create a visually appealing and user-friendly website.",
    },
    {
      id: 4,
      icon: <FaPlusSquare className="commonIcons" />,
      heading: "Clinical laboratory Services ",
      text: "I offer clinical laboratory services including the identification and characterization of microorganisms using techniques such as culture, microscopy, and molecular techniques to help diagnose and treat infectious diseases",
    },
    {
      id: 5,
      icon: <FaSearch className="commonIcons" />,
      heading: "Research and consulting",
      text: "I offer research and consulting services including designing and conducting experiments, analyzing data, and writing papers or presentations. I can provide guidance and support throughout the research process.",
    },
    {
      id: 6,
      icon: <FaBiohazard className="commonIcons" />,
      heading: "Quality control services ",
      text: "I offer quality control services including designing and implementing systems, conducting testing and analysis, and providing guidance on best practices. I have expertise in techniques such as culture, microscopy, and molecular techniques. I can help you ensure that your products or processes meet microbiological standards for purity and safety.",
    },
  ]);
  return (
    <div className="services">
      <div className="container">
        <div className="services__header">
          <div className="common">
            <h3 className="heading">{header.mainHeader}</h3>
            <h1 className="mainHeader">{header.subHeading}</h1>
            <p className="mainContent">{header.text}</p>
            <div className="commonBorder"></div>
          </div>

          <div className="row bgMain" data-aos="zoom-in">
            {state.map((info) => (
              <div className="col-4 bgMain">
                <div className="services__box">
                  {info.icon}
                  <div className="services__box-header " >{info.heading}</div>
                  <div className="services__box-p">{info.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
